module.exports = __webpack_public_path__ + "img/game11.0ad56e07.png";